<!--
 * @Description: 
 * @Date: 2021-09-23 17:33:36
-->
<template>
  <router-view v-slot="{ Component }" class="router">
    <!-- <transition name="zoom-fade" mode="out-in" appear> -->
    <keep-alive :include="keepAliveComponents" :max="5">
      <component :is="Component" />
    </keep-alive>
    <!-- </transition> -->
  </router-view>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import appStore from '@/store';

const keepAliveComponents = ref<any[]>([]);
const route = useRoute();
// const router = useRouter()
watch(
  () => route,
  v => {
    if (v.meta.keepAlive && keepAliveComponents.value.indexOf(v.name) === -1) {
      keepAliveComponents.value.push(v.name);
    }
  },
  { deep: true, immediate: true }
);
onMounted(() => {
  appStore.useUserStoreSetup.initUserSystemData();
});
</script>
<style lang="scss"></style>
